import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import withToggle from '../../../HOCs/withToggle';
import { View } from '../../../sic-lib/types/View';
import ToggleComponents from '../../Shared/ToggleComponents/ToggleComponents';
import ClientViewsItem from './ClientViewsItem/ClientViewsItem';
import ClientViewsItemCreate from './ClientViewsItemCreate/ClientViewsItemCreate';
import ClientViewsItemEdit from './ClientViewsItemEdit/ClientViewsItemEdit';

const ViewWithToggle = withToggle(ClientViewsItem, ClientViewsItemEdit);

interface Props {
    views: View[];
}

export default function ClientViews({ views }: Props) {
    return (
        <div className="clientViews">
            {
                <ToggleComponents>
                    {(toggle, onToggleHandler) =>
                        !toggle ? (
                            <Button
                                onClick={onToggleHandler}
                                startIcon={<AddIcon />}
                                sx={{ mb: 1 }}
                            >
                                Create Custom View
                            </Button>
                        ) : (
                            <ClickAwayListener onClickAway={onToggleHandler}>
                                <Box>
                                    <ClientViewsItemCreate onDoneHandler={onToggleHandler} />
                                </Box>
                            </ClickAwayListener>
                        )
                    }
                </ToggleComponents>
            }
            {views.map(
                view => view.viewId > -1 && <ViewWithToggle key={view.viewId} config={view} />,
            )}
        </div>
    );
}
